import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowedRoles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
    const { user } = useAuth();
    const userRole = user?.role || '';

    // Check if user role is in allowed roles
    const hasAccess = allowedRoles.includes(userRole);

    useEffect(() => {
        if (!hasAccess && user) {
            // Show notification (you can replace this with a toast library if preferred)
            console.warn('Access denied. That page is not available for your account.');
        }
    }, [hasAccess, user]);

    if (!hasAccess) {
        // Send each role to a page it can use: insights accounts land on
        // Analytics, everyone else (session_viewer) on Sessions.
        return <Navigate to={userRole === 'insights' ? '/dashboard' : '/sessions'} replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;

